













// import SDK from '../utils/sdk';
import { language, user, url, elk } from '@tencent/ppd-base-libs';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { unSupportTips } from '../config/index';
import { isInMiniProgram, isSupportH5ToWeapp } from '../utils/jsapiSupport';
import { showBusinessError } from '@tencent/wphk-components-dialog';

@Component({})
export default class LanuchWeapp extends Vue {
  public isSupportH5ToWeapp = isSupportH5ToWeapp();
  public id = Math.random().toString(); // 随机生成个id
  @Prop() private path!: string;
  // 所需跳转的小程序appid，即小程序对应的以wx开头的id
  @Prop() private appid!: string;
  // 所需跳转的小程序原始id，即小程序对应的以gh_开头的id（跳转时，有appid会优先使用appid，没有appid才会使用username）
  @Prop() private username!: string;
  // TODO: 后面给配置中心增加字段username，可以把h5跳三方小程序也配置化，只传merchantId就可
  @Prop() private merchantId?: string;

  public created() {
    if (!this.isSupportH5ToWeapp) {
      return;
    }
    console.log('====WEAPP LANUNCHER.INIT DONE');
    // 依赖外部初始化微信sdk，不在这里做init
    // SDK.init();
  }

  @Emit('weappClick')
  public weappClick() {
    if (isInMiniProgram() && this.merchantId) {
      this.jumpMpRedirectPage();
    } else if (!this.isSupportH5ToWeapp) {
      const lang = this.getLang();
      const errMsg = unSupportTips[lang];
      showBusinessError(errMsg);
    }
    return;
  }

  private jumpMpRedirectPage() {
    const uin = user.getUin();
    const adtag = url.getParamAdtag();
    const params = `merchantId=${this.merchantId}&uin=${uin}&adtag=${adtag}&lang=${this.getLang()}`;
    elk({
      key: 'jumpMpRedirectPage',
      msg: params,
    });
    //  跳转到本小程序中转页
    wx.miniProgram.navigateTo({
      // url: '/pages/busigift/index',
      url: `/pages/redirectpage/index?${params}`,
    });
  }

  private getLang() {
    const lang = language.getLang(['zh-cn', 'zh-hk', 'en'], {
      key: 'lang',
      defaultLang: 'zh-hk',
      keyMap: {
        // 台湾也和繁体中文一样处理
        'zh-tw': () => 'zh-hk',
      },
    });
    return lang;
  }

  private mounted() {
    const { id } = this;
    const btn: any = document.getElementById(id);
    if (btn) {
      const p = btn.parentElement.style.position;
      if (!p) {
        btn.parentElement.style.position = 'relative';
      }

      btn.addEventListener('launch', () => {
        // console.log('Launch success');
        // console.log(`Will open weapp : ${this.path}`);
      });
      btn.addEventListener('error', (e) => {
        showBusinessError();
        throw e;
      });
    }
  }
}
